import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";
import api, { formatApiError } from "@/lib/api";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("tark_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-tark-bg px-6" data-testid="admin-login-page">
      <div className="absolute inset-0 hero-grid opacity-30 [mask-image:radial-gradient(ellipse_60%_60%_at_50%_40%,black,transparent)]" />
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
                  className="relative w-full max-w-md rounded-2xl border border-tark-line bg-tark-card p-10">
        <Logo />
        <h1 className="mt-8 font-display text-2xl font-bold tracking-tight">Admin Console</h1>
        <p className="mt-2 text-sm text-tark-mut">Sign in to manage TARK content, leads and hiring.</p>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label htmlFor="admin-email" className="mb-1.5 block font-mono text-[10px] uppercase tracking-[0.2em] text-tark-dim">Email</label>
            <input id="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   className="w-full rounded-lg border border-tark-line bg-tark-bg px-4 py-3 text-sm text-tark-ink focus:border-tark-cyan/60 focus:outline-none"
                   data-testid="admin-login-email" />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-1.5 block font-mono text-[10px] uppercase tracking-[0.2em] text-tark-dim">Password</label>
            <input id="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                   className="w-full rounded-lg border border-tark-line bg-tark-bg px-4 py-3 text-sm text-tark-ink focus:border-tark-cyan/60 focus:outline-none"
                   data-testid="admin-login-password" />
          </div>
          {error && <p className="rounded-lg border border-red-500/40 bg-red-500/10 px-4 py-2.5 text-xs text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
                  className="w-full rounded-full bg-tark-blue py-3.5 font-display text-sm font-bold text-white transition-colors hover:bg-tark-vivid disabled:opacity-50">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
